import React from "react";
import { Link } from "react-router-dom";
import { getDateAgo } from "../../helper/Helper";
import { ArrowRight, Calendar } from "lucide-react";

function Card({ item }) {
  return (
    <article className="blog-card-root">
      <div className="card-media">
        <Link to={`/blog/${item?.slug}`}>
          <img src={item?.image} alt={item?.title} loading="lazy" />
        </Link>
      </div>

      <div className="card-content">
        <header>
          {item?.date && (
            <div className="card-badge mb-2">
              <Calendar size={12} className="me-1" />
              {new Date(item.date).toLocaleDateString("en-GB")}
            </div>
          )}
          <Link to={`/blog/${item?.slug}`} className="card-title-link">
            <h3 className="card-title">{item?.title}</h3>
          </Link>
        </header>

        <p className="card-excerpt">{item?.shortDescription}</p>

        <footer className="card-footer">
          <Link to={`/blog/${item?.slug}`} className="card-action">
            <span>Read Article</span>
            <div className="action-circle">
              <ArrowRight size={16} />
            </div>
          </Link>
        </footer>
      </div>
    </article>
  );
}

export default Card;
